function header() {
  return {
    mobileOpen: false,
    headerHeight: 0,
    announcementHeight: 0,
    isAtTop: true,

    init() {
      this.calculateHeights();
      window.addEventListener("scroll", () => this.handleScroll());
      // Initial check
      this.handleScroll();
    },

    handleScroll() {
      const scrolled = window.scrollY;
      this.isAtTop = scrolled <= this.announcementHeight;

      this.$dispatch("header-scroll-state", {
        isAtTop: this.isAtTop
      });
    },

    toggleMobile(isOpen) {
      this.mobileOpen = isOpen;
      this.$dispatch("toggle-mobile-header", isOpen);
    },

    calculateHeights() {
      const headerElement = this.$refs.header;
      const announcementElement = this.$refs.announcementBar;

      if (!headerElement) return;

      const updateHeights = () => {
        this.headerHeight = headerElement.offsetHeight;
        this.announcementHeight = announcementElement ? announcementElement.offsetHeight : 0;

        document.documentElement.style.setProperty("--header-height", `${this.headerHeight}px`);
        document.documentElement.style.setProperty("--announcement-bar-height", `${this.announcementHeight}px`);

        this.handleScroll();
      };

      updateHeights();
      const resizeObserver = new ResizeObserver(updateHeights);
      resizeObserver.observe(headerElement);
      if (announcementElement) {
        resizeObserver.observe(announcementElement);
      }
      this.$cleanup = () => resizeObserver.disconnect();
    }
  };
}

export default header;
